export enum RequestStatus {
  INITIAL,
  REQUESTED,
  SUCCEEDED,
  FAILED,
}
